/**
 * @generated SignedSource<<9b20e6c4671395c15e9c1b7086b55d50>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  qualifier?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type AppQuery$variables = {
  filterElement?: FilterElementInput | null | undefined;
};
export type AppQuery$data = {
  readonly platform: {
    readonly cloudCustodianVersion: string;
    readonly version: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ApiExplorerSync_query" | "ColorSchemeSync_query" | "Routes_accounts" | "SideBarWrapper_query" | "UserContext_platform">;
};
export type AppQuery = {
  response: AppQuery$data;
  variables: AppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterElement"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cloudCustodianVersion",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "filterElement",
    "variableName": "filterElement"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "UserDataEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserData",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        (v4/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v5/*:: as any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userPermissions",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "problems",
  "plural": true,
  "selections": [
    (v8/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ApiExplorerSync_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ColorSchemeSync_query"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Platform",
        "kind": "LinkedField",
        "name": "platform",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Routes_accounts"
      },
      {
        "args": (v3/*:: as any*/),
        "kind": "FragmentSpread",
        "name": "SideBarWrapper_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserContext_platform"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AppQuery",
    "selections": [
      {
        "alias": "apiExplorer",
        "args": [
          {
            "kind": "Literal",
            "name": "filterElement",
            "value": {
              "single": {
                "name": "name",
                "operator": "equals",
                "value": "api_explorer"
              }
            }
          }
        ],
        "concreteType": "UserDataConnection",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": (v6/*:: as any*/),
        "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"api_explorer\"}})"
      },
      {
        "alias": "colorScheme",
        "args": [
          {
            "kind": "Literal",
            "name": "filterElement",
            "value": {
              "single": {
                "name": "name",
                "operator": "equals",
                "value": "color_scheme"
              }
            }
          }
        ],
        "concreteType": "UserDataConnection",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": (v6/*:: as any*/),
        "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"color_scheme\"}})"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Platform",
        "kind": "LinkedField",
        "name": "platform",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CostReportingConfig",
            "kind": "LinkedField",
            "name": "costReportingConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "awsCostType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "azureCostType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gcpCostType",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoleScopes",
            "kind": "LinkedField",
            "name": "roleScopes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleScope",
                "kind": "LinkedField",
                "name": "accountGroup",
                "plural": false,
                "selections": (v7/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleScope",
                "kind": "LinkedField",
                "name": "policyCollection",
                "plural": false,
                "selections": (v7/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleScope",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": (v7/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleScope",
                "kind": "LinkedField",
                "name": "system",
                "plural": false,
                "selections": (v7/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountConnection",
        "kind": "LinkedField",
        "name": "accounts",
        "plural": false,
        "selections": [
          (v9/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Config",
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOnboardingSkipped",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ssoUser",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jun0",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "redash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sinistral",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "superset",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": "analytics",
        "args": [
          {
            "kind": "Literal",
            "name": "filterElement",
            "value": {
              "single": {
                "name": "name",
                "operator": "equals",
                "value": "analytics_enabled"
              }
            }
          }
        ],
        "concreteType": "UserDataConnection",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*:: as any*/)
            ],
            "type": "Problems",
            "abstractKey": "__isProblems"
          }
        ],
        "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"analytics_enabled\"}})"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "DashboardConnection",
        "kind": "LinkedField",
        "name": "dashboards",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DashboardEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Dashboard",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*:: as any*/),
        "concreteType": "Jun0ThreadConnection",
        "kind": "LinkedField",
        "name": "jun0Threads",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Jun0ThreadEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Jun0Thread",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created",
                    "storageKey": null
                  },
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "jun0Threads(first:25)"
      },
      {
        "alias": null,
        "args": (v10/*:: as any*/),
        "filters": [
          "filterElement"
        ],
        "handle": "connection",
        "key": "ChatThreadsList_jun0Threads",
        "kind": "LinkedHandle",
        "name": "jun0Threads"
      },
      {
        "alias": "avatarColor",
        "args": [
          {
            "kind": "Literal",
            "name": "filterElement",
            "value": {
              "single": {
                "name": "name",
                "operator": "equals",
                "value": "avatar_color"
              }
            }
          }
        ],
        "concreteType": "UserDataConnection",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": (v6/*:: as any*/),
        "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"avatar_color\"}})"
      }
    ]
  },
  "params": {
    "cacheID": "9759bed8bd132dc8d522ed72ba8e71da",
    "id": null,
    "metadata": {},
    "name": "AppQuery",
    "operationKind": "query",
    "text": "query AppQuery(\n  $filterElement: FilterElementInput\n) {\n  ...ApiExplorerSync_query\n  ...ColorSchemeSync_query\n  platform {\n    cloudCustodianVersion\n    version\n    id\n  }\n  ...Routes_accounts\n  ...SideBarWrapper_query_2g1q2o\n  ...UserContext_platform\n}\n\nfragment ApiExplorerSync_query on Query {\n  apiExplorer: userData(filterElement: {single: {name: \"name\", operator: \"equals\", value: \"api_explorer\"}}) {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment AppVersion_version on Platform {\n  cloudCustodianVersion\n  version\n}\n\nfragment ChatThreadsList_query on Query {\n  jun0Threads(first: 25) {\n    edges {\n      node {\n        id\n        uuid\n        name\n        created\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ColorSchemeSync_query on Query {\n  colorScheme: userData(filterElement: {single: {name: \"name\", operator: \"equals\", value: \"color_scheme\"}}) {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment NavBarUserMenu_query on Query {\n  platform {\n    ...AppVersion_version\n    id\n  }\n  ...PreferencesDialog_query\n}\n\nfragment PreferencesDialog_query on Query {\n  whoami {\n    displayName\n  }\n  analytics: userData(filterElement: {single: {name: \"name\", operator: \"equals\", value: \"analytics_enabled\"}}) {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n    ...useProblemsAlert_problems\n  }\n}\n\nfragment Routes_accounts on Query {\n  accounts {\n    problems {\n      __typename\n      message\n    }\n    pageInfo {\n      total\n    }\n  }\n  whoami {\n    __typename\n  }\n}\n\nfragment SideBarWrapper_query_2g1q2o on Query {\n  ...NavBarUserMenu_query\n  ...useEnabledDashboards_query_2g1q2o\n  ...ChatThreadsList_query\n}\n\nfragment UserContext_platform on Query {\n  platform {\n    costReportingConfig {\n      awsCostType\n      azureCostType\n      gcpCostType\n      id\n    }\n    roleScopes {\n      accountGroup {\n        userPermissions\n      }\n      policyCollection {\n        userPermissions\n      }\n      repository {\n        userPermissions\n      }\n      system {\n        userPermissions\n      }\n    }\n    id\n  }\n  whoami {\n    email\n    displayName\n    user {\n      ssoUser\n      id\n    }\n  }\n  avatarColor: userData(filterElement: {single: {name: \"name\", operator: \"equals\", value: \"avatar_color\"}}) {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment useEnabledDashboards_query_2g1q2o on Query {\n  dashboards(filterElement: $filterElement) {\n    edges {\n      node {\n        key\n        title\n        id\n      }\n    }\n  }\n}\n\nfragment useProblemsAlert_problems on Problems {\n  __isProblems: __typename\n  problems {\n    __typename\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "f22bfc0f67714e38e131f6d7ffabe1de";

export default node;
